<template>
    <div class="page">
        <header>
            <!-- !Мова -->
            <!-- <div class="header-lang" @click="isLangOpen = !isLangOpen">
                <div class="header-lang-c">
                    <p class="header-lang-text">{{ langData.currentLang.toUpperCase() }}</p>
                    <svg class="header-lang-icon-arrow" width="16" height="8" viewBox="0 0 16 8" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M15 1L9.55563 6.44437C8.69648 7.30352 7.30352 7.30352 6.44436 6.44436L1 0.999999"
                            stroke="#434343" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                <div :class="'header-lang-b ' + (isLangOpen ? 'open' : 'close')">
                    <p class="header-lang-text-b" @click="changeLanguage(langData.nextLang)">{{
                langData.nextLang.toUpperCase() }}</p>
                </div>
            </div> -->
            <template v-if="companyConfig.logoStartPage">
                <img class="header-bg" :src="companyConfig.logoStartPage" />
            </template>
            <template v-else>
                <img class="header-bg" src="../../public/img/qr-code-counter-bar.jpg" />
            </template>
            <!-- <img class="header-bg" src="../../public/img/qr-code-counter-bar.jpg" /> -->
            <!-- Лого закладу -->
            <div class="header-logo-c">
                <template v-if="!companyConfig.companyLogo">
                    <img class="header-logo-img" src="../../public/img/Skyservice_logo_2022_512.png" />
                </template>
                <template v-else>
                    <img class="header-logo-img" :src="companyConfig.companyLogo" />
                </template>
            </div>

        </header>

        <main>
            <div class="hero-c">
                <!-- Назва Компанії -->
                <div class="title-shop-c">
                    <h2 class="title-shop">{{ companyConfig.companyName }}</h2>
                </div>

                <div class="hero-btn-g-g">
                    <!-- Меню -->
                    <div v-if="isActiveMenu" class="hero-btn-g" @click.prevent="openMenu"
                        :style="{ background: buttonWhite ? 'rgb(255, 255, 255)' : 'var(--button) !important' }">
                        <div class="hero-btn-c">
                            <svg class="hero-btn-icon-start" width="28" height="17" viewBox="0 0 28 17" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M11.6764 0.174492C11.0776 0.746956 11.4885 1.21768 12.6112 1.24552L13.3448 1.26369V1.85919C13.3448 2.34433 13.3301 2.45469 13.2656 2.45469C7.88791 2.45469 2.96591 7.2572 2.55282 12.9075L2.51982 13.3587L1.96427 13.3802C-0.119867 13.461 -0.750153 15.9207 1.07898 16.8351L1.40876 17H14.0003H26.5918L26.9075 16.8472C28.754 15.9532 28.1247 13.4612 26.0319 13.3801C25.724 13.3681 25.4719 13.3434 25.4719 13.3251C25.4495 7.73069 20.2383 2.45469 14.735 2.45469C14.6705 2.45469 14.6558 2.3437 14.6558 1.85407V1.25346L15.2977 1.25053C16.4582 1.2452 16.9613 0.726221 16.3364 0.178774L16.1323 0H13.9957H11.8589L11.6764 0.174492ZM14.9368 3.71065C20.0637 4.20649 24.1609 8.39842 24.1609 13.1479V13.3702H14.0003H3.83967V13.1668C3.83967 7.70792 9.18356 3.15422 14.9368 3.71065ZM11.4875 6.09222C10.6343 6.21469 10.1158 6.3944 9.46691 6.79232C8.44325 7.42015 7.47248 8.78406 7.66973 9.31731C7.89676 9.93087 8.70191 9.87598 8.9243 9.23176C9.27364 8.21964 10.4501 7.45618 11.8702 7.32003C12.4395 7.2654 12.658 7.13238 12.7231 6.80073C12.8276 6.26833 12.3135 5.97361 11.4875 6.09222ZM26.5057 14.7844C26.7939 15.0599 26.7204 15.5397 26.3633 15.7143C26.2764 15.7568 22.9104 15.7727 14.0003 15.7727C5.09024 15.7727 1.72418 15.7568 1.63732 15.7143C1.28017 15.5397 1.2067 15.0599 1.49491 14.7844L1.663 14.6237H14.0003H26.3376L26.5057 14.7844Z"
                                    :style="{ fill: buttonWhite ? 'var(--button)' : 'var(--text-button) !important' }" />
                            </svg>
                            <h2 :style="{ color: buttonWhite ? 'rgb(67, 67, 67)' : 'var(--text-button) !important' }"
                                class="hero-btn-title">{{ lang['menu'] }}</h2>
                        </div>
                        <div class="hero-btn-c">
                            <svg class="hero-btn-icon-arrow-right" width="9" height="16" viewBox="0 0 9 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.5 1L6.94437 6.44437C7.80352 7.30352 7.80352 8.69648 6.94437 9.55564L1.5 15"
                                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                                    :style="{ stroke: buttonWhite ? 'var(--button)' : 'var(--text-button) !important' }" />
                            </svg>

                        </div>
                    </div>
                    <!-- Оплата -->
                    <div v-if="!isWithoutPay" class="hero-btn-g" @click="openPay"
                        :style="{ background: buttonWhite ? 'rgb(255, 255, 255)' : 'var(--button) !important' }">
                        <div class="hero-btn-c">
                            <svg width="26" height="20" viewBox="0 0 26 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <rect x="1.25" y="1.25" width="23.5" height="17.5" rx="2.75"
                                    :style="{ stroke: buttonWhite ? 'var(--button)' : 'var(--text-button) !important' }"
                                    stroke-width="1.5" />
                                <path d="M1 7L24 7" stroke-width="1.5"
                                    :style="{ stroke: buttonWhite ? 'var(--button)' : 'var(--text-button) !important' }" />
                                <path d="M18 14H21" stroke-width="1.5" stroke-linecap="round"
                                    :style="{ stroke: buttonWhite ? 'var(--button)' : 'var(--text-button) !important' }" />
                            </svg>

                            <h2 :style="{ color: buttonWhite ? 'rgb(67, 67, 67)' : 'var(--text-button) !important' }"
                                class="hero-btn-title">{{ lang['oplata'] }}</h2>
                        </div>
                        <div class="hero-btn-c">
                            <svg class="hero-btn-icon-arrow-right" width="9" height="16" viewBox="0 0 9 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.5 1L6.94437 6.44437C7.80352 7.30352 7.80352 8.69648 6.94437 9.55564L1.5 15"
                                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                                    :style="{ stroke: buttonWhite ? 'var(--button)' : 'var(--text-button) !important' }" />
                            </svg>

                        </div>
                    </div>
                    <!-- ! Викликати офіціанта -->
                    <div v-if="isActivewaiter" class="hero-btn-g" @click="!isWaiterWasCall && callWaiter()"
                        :style="{ background: buttonWhite ? 'rgb(255, 255, 255)' : 'var(--button) !important' }">
                        <div class="hero-btn-c">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13.2651 11.62C13.2323 11.62 13.2105 11.62 13.1778 11.62C13.1233 11.61 13.0469 11.61 12.9814 11.62C9.8178 11.53 7.42871 9.25 7.42871 6.44C7.42871 3.58 9.97053 1.25 13.0905 1.25C16.2105 1.25 18.7523 3.58 18.7523 6.44C18.7414 9.25 16.3414 11.53 13.2978 11.62C13.2869 11.62 13.276 11.62 13.2651 11.62ZM13.0905 2.75C10.876 2.75 9.06507 4.41 9.06507 6.44C9.06507 8.44 10.7669 10.05 12.9378 10.12C12.9923 10.11 13.1451 10.11 13.2869 10.12C15.4251 10.03 17.1051 8.42 17.116 6.44C17.116 4.41 15.3051 2.75 13.0905 2.75Z"
                                    :style="{ fill: buttonWhite ? 'var(--button)' : 'var(--text-button) !important' }" />
                                <path
                                    d="M13.276 22.55C11.1378 22.55 8.98873 22.05 7.36328 21.05C5.84691 20.13 5.01782 18.87 5.01782 17.5C5.01782 16.13 5.84691 14.86 7.36328 13.93C10.636 11.94 15.9378 11.94 19.1887 13.93C20.6942 14.85 21.5342 16.11 21.5342 17.48C21.5342 18.85 20.7051 20.12 19.1887 21.05C17.5524 22.05 15.4142 22.55 13.276 22.55ZM8.26873 15.19C7.22146 15.83 6.65419 16.65 6.65419 17.51C6.65419 18.36 7.23237 19.18 8.26873 19.81C10.9851 21.48 15.5669 21.48 18.2833 19.81C19.3306 19.17 19.8978 18.35 19.8978 17.49C19.8978 16.64 19.3196 15.82 18.2833 15.19C15.5669 13.53 10.9851 13.53 8.26873 15.19Z"
                                    :style="{ fill: buttonWhite ? 'var(--button)' : 'var(--text-button) !important' }" />
                            </svg>

                            <h2 :style="{ color: buttonWhite ? 'rgb(67, 67, 67)' : 'var(--text-button) !important' }"
                                class="hero-btn-title">{{ lang['callWaiter'] }}</h2>
                            <svg v-if="isWaiterWasCall" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="25"
                                height="25" viewBox="0 0 48 48">
                                <path :style="{ fill: 'var(--button)' }"
                                    d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z">
                                </path>
                                <path fill="#ccff90"
                                    d="M34.602,14.602L21,28.199l-5.602-5.598l-2.797,2.797L21,33.801l16.398-16.402L34.602,14.602z">
                                </path>
                            </svg>
                        </div>
                    </div>
                    <!-- Відгуки -->
                    <div v-if="isActiveReviews" class="hero-btn-g"
                        :style="{ background: buttonWhite ? 'rgb(255, 255, 255)' : 'var(--button) !important' }"
                        @click="Openreviews">
                        <div class="hero-btn-c">
                            <svg width="17" height="18" viewBox="0 0 17 18" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M9.30811 5.62134L9.02538 7.36185H10.7887H12.2556C12.662 7.36185 13.2328 7.618 13.7744 8.45455C14.3062 9.2762 14.6842 10.5011 14.6842 11.9309C14.6842 13.3607 14.3062 14.5856 13.7744 15.4073C13.2328 16.2438 12.662 16.5 12.2556 16.5H5.39471V7.36187V6.87771L5.57828 6.39672L7.13911 2.30728C7.30982 1.98024 7.63811 1.71112 8.05576 1.57921C8.49993 1.43893 8.89151 1.4999 9.12676 1.64098C9.6487 1.95399 9.72849 2.20939 9.76073 2.39143C9.8169 2.70864 9.75803 3.0969 9.62024 3.79027L9.61824 3.80035C9.5838 3.97364 9.54479 4.16996 9.51211 4.36562L9.5121 4.36562L9.51103 4.37219L9.30811 5.62134ZM5.39471 18V18H3.89471H1C0.447717 18 0 17.5523 0 17V6.86187C0 6.30959 0.447715 5.86187 1 5.86187H3.59659V5.86185H4.17689L5.76271 1.7069C6.49683 0.157615 8.56024 -0.447834 9.89823 0.354576C11.6263 1.39095 11.3444 2.80971 11.0915 4.08262L11.0914 4.0828C11.0728 4.17668 11.0543 4.26977 11.0368 4.36185C11.0207 4.44637 11.0054 4.53004 10.9916 4.6127L10.7887 5.86185H12.2556C12.2732 5.86185 12.2907 5.86203 12.3083 5.86239C14.4537 5.90595 16.1842 8.60623 16.1842 11.9309C16.1842 15.2828 14.4253 18 12.2556 18H5.39471ZM3.59659 7.36187V16.5V16.5H1.5V7.36187H3.59659Z"
                                    fill="#434343"
                                    :style="{ fill: buttonWhite ? 'var(--button)' : 'var(--text-button) !important' }" />
                            </svg>


                            <h2 :style="{ color: buttonWhite ? 'rgb(67, 67, 67)' : 'var(--text-button) !important' }"
                                class="hero-btn-title">Залишити відгук</h2>
                        </div>
                    </div>
                    <!-- Попросити рахунок -->
                    <!-- <div v-if="isActivewaiter" class="hero-btn-g" @click="callPay"
                    :style="{ background: buttonWhite ? 'rgb(255, 255, 255)' : 'var(--button) !important' }"
                    >
                        <div class="hero-btn-c">
                            <svg width="26" height="26" viewBox="0 0 26 26" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13 24.6459C12.155 24.6459 11.3316 24.2126 10.7683 23.4542L9.67413 21.9917C9.44663 21.6884 9.14329 21.5151 8.81829 21.4934C8.49329 21.4826 8.16829 21.6234 7.90829 21.8942L7.29079 21.3417L7.88663 21.8942C6.32663 23.5626 5.12413 23.4326 4.54996 23.2051C3.96496 22.9776 2.97913 22.2301 2.97913 19.8251V7.62675C2.97913 2.81675 4.36579 1.35425 8.90496 1.35425H17.095C21.6341 1.35425 23.0208 2.81675 23.0208 7.62675V19.8251C23.0208 22.2192 22.035 22.9667 21.45 23.2051C20.8758 23.4326 19.6841 23.5626 18.1133 21.8942C17.8533 21.6126 17.5391 21.4609 17.1925 21.4934C16.8675 21.5151 16.5533 21.6884 16.3258 21.9917L15.2316 23.4542C14.6683 24.2126 13.845 24.6459 13 24.6459ZM8.75329 19.8576C8.79663 19.8576 8.85079 19.8576 8.89413 19.8576C9.69579 19.9009 10.4541 20.3234 10.9633 21.0059L12.0575 22.4684C12.5883 23.1726 13.4008 23.1726 13.9316 22.4684L15.0258 21.0059C15.5458 20.3234 16.2933 19.9009 17.1058 19.8576C17.9075 19.8142 18.7091 20.1501 19.2941 20.7784C20.1175 21.6559 20.6591 21.7642 20.8433 21.6884C21.1033 21.5801 21.385 20.9517 21.385 19.8251V7.62675C21.385 3.71591 20.7025 2.97925 17.0841 2.97925H8.90496C5.28663 2.97925 4.60413 3.71591 4.60413 7.62675V19.8251C4.60413 20.9626 4.88579 21.5909 5.14579 21.6884C5.32996 21.7642 5.87163 21.6559 6.69496 20.7784C7.27996 20.1826 8.00579 19.8576 8.75329 19.8576Z"
                                    :style="{ fill: buttonWhite ? 'var(--button)' : 'var(--text-button) !important' }" />
                                <path
                                    d="M17.3333 8.39575H8.66663C8.22246 8.39575 7.85413 8.02742 7.85413 7.58325C7.85413 7.13909 8.22246 6.77075 8.66663 6.77075H17.3333C17.7775 6.77075 18.1458 7.13909 18.1458 7.58325C18.1458 8.02742 17.7775 8.39575 17.3333 8.39575Z"
                                    :style="{ fill: buttonWhite ? 'var(--button)' : 'var(--text-button) !important' }" />
                                <path
                                    d="M16.25 12.7292H9.75C9.30583 12.7292 8.9375 12.3609 8.9375 11.9167C8.9375 11.4726 9.30583 11.1042 9.75 11.1042H16.25C16.6942 11.1042 17.0625 11.4726 17.0625 11.9167C17.0625 12.3609 16.6942 12.7292 16.25 12.7292Z"
                                    :style="{ fill: buttonWhite ? 'var(--button)' : 'var(--text-button) !important' }" />
                            </svg>


                            <h2 :style="{ color: buttonWhite ? 'rgb(67, 67, 67)' : 'var(--text-button) !important' }" class="hero-btn-title">{{ lang['callPay'] }}</h2>
                        </div>

                    </div> -->
                </div>
            </div>
            <!-- Графік роботи -->
            <div v-if="useWorkTime && isAnyWorkTimeOpen" class="shedule-g">
                <div class="shedule-title-g">
                    <div class="shedule-title-c">
                        <svg class="shedule-title-icon-menu" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M14.2798 4.94864L9.75981 4.94864V3.75737L14.2798 3.75737V4.94864ZM21.0796 6.12618L21.0796 19.0789C21.0796 19.7078 20.8396 20.311 20.4123 20.7563C19.9849 21.2016 19.405 21.4527 18.7998 21.4545L5.17358 21.4545C4.57359 21.4509 3.99945 21.2002 3.57705 20.7575C3.15465 20.3147 2.91844 19.716 2.9202 19.0926L2.9202 6.09171C2.91846 5.78244 2.97537 5.47585 3.08767 5.18943C3.19997 4.90301 3.36546 4.6424 3.57471 4.42244C3.78395 4.20247 4.03286 4.02747 4.3072 3.90745C4.58153 3.78743 4.87592 3.72471 5.17358 3.7229V4.94864C4.87177 4.94862 4.58211 5.07226 4.36747 5.2927C4.15282 5.51314 4.03052 5.81262 4.02703 6.12618V8.47431L19.9331 8.47431V6.12618C19.9296 5.81262 19.8073 5.51314 19.5926 5.2927C19.378 5.07226 19.0883 4.94862 18.7865 4.94864V3.75737C19.3912 3.75737 19.971 4.00691 20.3986 4.45114C20.8262 4.89538 21.0664 5.49793 21.0664 6.12618H21.0796ZM7.44681 17.2747H4.02703V19.0444C4.02703 19.361 4.14758 19.6647 4.36241 19.8893C4.57724 20.1138 4.86888 20.2408 5.17358 20.2426H7.44681V17.2747ZM7.44681 13.7491H4.02703V16.0972H7.44681V13.7491ZM7.44681 9.61742H4.02703L4.02703 12.5715H7.44681L7.44681 9.61742ZM11.4233 17.2747H8.58014V20.2426H11.3968L11.4233 17.2747ZM11.4233 13.7491H8.58014V16.0972H11.3968L11.4233 13.7491ZM11.4233 9.61742L8.58014 9.61742L8.58014 12.5715H11.3968L11.4233 9.61742ZM15.3998 17.2747H12.5567L12.5567 20.2426L15.3998 20.2426L15.3998 17.2747ZM15.3998 13.7491H12.5567V16.0972H15.3998V13.7491ZM15.3998 9.61742H12.5567V12.5715H15.3998V9.61742ZM19.9265 17.2747L16.5066 17.2747L16.5066 20.2426H18.7799C19.0828 20.2426 19.3734 20.1181 19.5883 19.8961C19.8031 19.6742 19.9247 19.373 19.9265 19.0582V17.2747ZM19.9265 13.7491L16.5066 13.7491V16.0972L19.9265 16.0972V13.7491ZM19.9265 9.61742L16.5066 9.61742V12.5715L19.9265 12.5715V9.61742ZM6.88349 6.09171L8.03004 6.09171C8.17831 6.09172 8.3206 6.03104 8.42606 5.92276C8.53152 5.81447 8.59162 5.66735 8.59336 5.51331V3.1445C8.59513 3.06648 8.58189 2.98889 8.55437 2.91628C8.52685 2.84367 8.48562 2.7775 8.43314 2.72168C8.38065 2.66586 8.31795 2.62149 8.24872 2.59122C8.17949 2.56095 8.10515 2.54539 8.03004 2.54541L6.88349 2.54541C6.80838 2.54539 6.734 2.56095 6.66477 2.59122C6.59555 2.62149 6.53284 2.66586 6.48035 2.72168C6.42787 2.7775 6.38668 2.84367 6.35916 2.91628C6.33164 2.98889 6.31836 3.06648 6.32013 3.1445V5.51331C6.32187 5.66735 6.38202 5.81447 6.48747 5.92276C6.59293 6.03104 6.73523 6.09172 6.88349 6.09171ZM15.9698 6.09171H17.0766C17.1506 6.09262 17.224 6.07839 17.2927 6.04981C17.3614 6.02123 17.424 5.97891 17.4769 5.92519C17.5298 5.87148 17.572 5.80745 17.6012 5.73678C17.6303 5.66611 17.6457 5.59017 17.6466 5.51331V3.1445C17.6475 3.06615 17.6334 2.98838 17.6051 2.91573C17.5769 2.84308 17.535 2.77703 17.482 2.7213C17.429 2.66558 17.3659 2.62133 17.2963 2.59114C17.2267 2.56095 17.152 2.5454 17.0766 2.54541H15.9698C15.8944 2.5454 15.8197 2.56095 15.7502 2.59114C15.6806 2.62133 15.6175 2.66558 15.5644 2.7213C15.5114 2.77703 15.4696 2.84308 15.4413 2.91573C15.4131 2.98838 15.399 3.06615 15.3998 3.1445V5.51331C15.4033 5.66797 15.4649 5.81508 15.5714 5.92318C15.6779 6.03128 15.8209 6.09176 15.9698 6.09171Z"
                                :style="{ fill: 'var(--text-head)' }" />
                        </svg>
                        <h2 :style="{ color: 'var(--text-head)' }" class="shedule-title">{{ lang['graph'] }}</h2>
                        <div :class="{ open: isOpenShedule }" class="shedule-title-c"
                            @click="isOpenShedule = !isOpenShedule">



                            <svg class="shedule-icon-arrow" width="16" height="8" viewBox="0 0 16 8" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M15 1L9.55563 6.44437C8.69648 7.30352 7.30352 7.30352 6.44436 6.44436L1 0.999999"
                                    :style="{ stroke: 'var(--text-head)' }" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </div>

                    </div>
                    <div class="shedule-title-c">
                        <div v-if="currentDate"
                            :class="'shedule-title-right ' + (currentDate.isOpenNow ? 'open' : 'close')">
                            <div :style="{ background: currentDate.isOpenNow ? 'rgb(65, 187, 83)' : 'red' }"
                                class="shedule-title-ball"></div>
                            <p class="shedule-title-text">{{ currentDate.isOpenNow ? lang['open'] : lang['closed'] }}</p>
                        </div>
                    </div>
                </div>

                <div class="shedule-menus-g">
                    <div :style="{ color: 'var(--text-head)' }"
                        :class="'shedule-menus-c ' + (isOpenShedule ? 'open' : 'close')">
                        <div class="shedule-menus-cont-menu">
                            <div v-if="currentDate" class="shedule-menus-c-cont">
                                <span class="shedule-day-week">{{ lang[currentDate.name] }}</span>
                                <span v-if="currentDate.isOpen" class="shedule-time-work">{{ currentDate.startTiem }} -
                                    {{ currentDate.endTiem }}</span>
                                <span v-else class="shedule-time-work">{{ lang['closed'] }}</span>
                            </div>
                            <!-- opener -->
                            <div class="shedule-menus-cont-menu-list">

                                <template v-for="time of workTimeArray">
                                    <div :key="time.name" v-if="time.isOpen"
                                        :class="'shedule-menus-c-cont ' + (currentDate.name === time.name ? 'current' : '')">
                                        <span class="shedule-day-week">{{ lang[time.name] }}</span>
                                        <span class="shedule-time-work">{{ time.startTiem }} - {{ time.endTiem }}</span>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <!-- <svg class="shedule-icon-arrow" @click="isOpenShedule = !isOpenShedule" width="16" height="8"
                            viewBox="0 0 16 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15 1L9.55563 6.44437C8.69648 7.30352 7.30352 7.30352 6.44436 6.44436L1 0.999999"
                            :style="{ stroke: 'var(--text-head)' }" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg> -->

                    </div>

                </div>
            </div>

            <!-- Телефон -->
            <!-- <div class="hero-btn-g m-t-20 "> -->
            <div v-if="phoneNumber" class="hero-btn-c gap-20 bottom-container">
                <svg width="22" height="22" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M3.88291 4.18417C5.55629 2.52042 8.31179 2.81604 9.71291 4.68879L11.4482 7.00429C12.5894 8.52779 12.4877 10.6563 11.1333 12.0024L10.806 12.3297C10.7689 12.467 10.7652 12.6113 10.795 12.7504C10.8817 13.3114 11.3505 14.4994 13.314 16.4519C15.2775 18.4044 16.4738 18.8719 17.043 18.9599C17.1865 18.9888 17.3346 18.9845 17.4762 18.9475L18.0372 18.3893C19.2417 17.193 21.0897 16.9689 22.5802 17.7788L25.2064 19.2088C27.4573 20.4298 28.0252 23.4878 26.1827 25.3207L24.2288 27.2622C23.6128 27.874 22.785 28.3842 21.7758 28.479C19.287 28.7114 13.4887 28.4144 7.39329 22.3548C1.70491 16.698 0.613162 11.7645 0.474287 9.33354C0.405537 8.10429 0.985787 7.06479 1.72554 6.33054L3.88291 4.18417ZM8.06291 5.92492C7.36579 4.99404 6.06779 4.91979 5.33629 5.64717L3.17754 7.79217C2.72379 8.24317 2.50654 8.74092 2.53404 9.21667C2.64404 11.1485 3.52404 15.5994 8.84804 20.8932C14.4333 26.4454 19.5909 26.6118 21.5847 26.4248C21.9917 26.3877 22.3959 26.1759 22.774 25.8005L24.7265 23.8577C25.5213 23.0684 25.3467 21.6302 24.2219 21.0197L21.5957 19.591C20.8697 19.1978 20.0199 19.327 19.4919 19.8523L18.8663 20.4752L18.1375 19.7437C18.8663 20.4752 18.8649 20.4765 18.8635 20.4765L18.8622 20.4793L18.858 20.4834L18.8484 20.4917L18.8278 20.5109C18.7698 20.5648 18.7072 20.6136 18.6408 20.6567C18.5308 20.7295 18.385 20.8107 18.2022 20.878C17.8309 21.0169 17.3387 21.0912 16.7309 20.9977C15.5388 20.8148 13.9589 20.0022 11.8593 17.9149C9.76104 15.8277 8.94154 14.2574 8.75729 13.0667C8.66241 12.4589 8.73804 11.9667 8.87829 11.5954C8.95548 11.3865 9.06599 11.1915 9.20554 11.0179L9.24954 10.9698L9.26879 10.9492L9.27704 10.9409L9.28116 10.9368L9.28391 10.934L9.67991 10.5408C10.2684 9.95367 10.3509 8.98154 9.79679 8.24042L8.06291 5.92492Z"
                        :style="{ fill: 'var(--text-head)' }" />
                </svg>

                <a :style="{ color: 'var(--text-head)' }" :href="'tel:' + phoneNumber" class="hero-btn-title phone">{{
                    phoneNumber }}</a>
            </div>
            <!-- </div> -->

            <!-- !Карта -->
            <!-- class="hero-btn-g m-t-20 center-row" -->
            <!-- <div > -->
            <div v-if="contacts" class="hero-btn-c bottom-container">
                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M15.4062 5.17266L1.6624 0.078125L1.6499 0.0742188C1.19856 -0.0811832 0.698116 0.0340333 0.360165 0.371153C0.0222147 0.708273 -0.0942326 1.20843 0.0600586 1.66016C0.0610085 1.66442 0.0623152 1.66861 0.0639648 1.67266L5.1624 15.4164C5.33414 15.919 5.80864 16.255 6.33975 16.25H6.36318C6.90533 16.2459 7.38105 15.8878 7.53506 15.368L9.37568 9.38672L15.3569 7.54609C15.8724 7.38747 16.228 6.91611 16.239 6.37688C16.25 5.83766 15.914 5.35218 15.4054 5.17266H15.4062ZM14.9897 6.35156L9.0085 8.19219C8.61318 8.31398 8.30372 8.62344 8.18193 9.01875L6.34131 15L6.33662 14.9867L1.23975 1.25L14.9757 6.34531L14.9882 6.35L14.9897 6.35156Z"
                        :style="{ fill: 'var(--text-head)' }" />
                </svg>
                <h2 :style="{ color: 'var(--text-head)' }" class="hero-btn-title adress-text">
                    <a :href="googleMapsLink" target="_blank" rel="noopener noreferrer">{{ contacts }}</a>
                </h2>
            </div>
            <!-- </div> -->


        </main>
        <!-- Верстка та типографіка футера повторюють AppFooter.vue у qr-menu:
             для гостя це один продукт, і низ сторінки має виглядати однаково. -->
        <footer>
            <!-- Знаки в один рядок із посиланням на умови, а не окремим третім
                 рядком: футер зі стартового екрана й так помітний. До «Powered
                 by» їх не ставимо навмисно — поруч із назвою Skyservice це
                 читалося б як спільний лок-ап, а знаки позначають прийом карток
                 закладом, не нами.

                 Самі знаки дублюємо у футері, хоч правила Visa/Mastercard
                 говорять про екран оплати: до нього модератор акваєра не дійде —
                 туди треба живий відкритий рахунок на реальному столі. Стартова
                 сторінка й умови — єдине, що перевірка бачить. -->
            <div class="footer-row">
                <TermsLinks />
                <CardBrandsMark compact />
            </div>
            <span class="footer-title">
                Powered by
                <a class="footer-text" target="_blank" rel="noopener noreferrer"
                    href="https://skyservice.pro">Skyservice POS</a>
            </span>
        </footer>
    </div>

</template>
<script>

import { sendSocketTypayGuest } from "./tpayConnect"
import { store } from "@/store.js";
import { navigator } from './configRoutes';
import TermsLinks from './TermsLinks.vue';
import CardBrandsMark from './CardBrandsMark.vue';

function getIsCurrentWorkTimeIn(startTiem, endTiem) {
    const now = new Date();
    const currentTime = now.getHours() * 60 + now.getMinutes();

    const [startHours, startMinutes] = startTiem.split(':').map(Number);
    const [endHours, endMinutes] = endTiem.split(':').map(Number);

    const startTime = startHours * 60 + startMinutes;
    const endTime = endHours * 60 + endMinutes;

    if (startTime <= endTime) return currentTime >= startTime && currentTime <= endTime;
    else return currentTime >= startTime || currentTime <= endTime;

}

export default {
    props: ['companyConfig', "isActiveMenu", "isActivewaiter", "workTime", "hallId", "tradepointId", "tableId", "isWaiterWasCall", "linkMenu", "useWorkTime", "isWithoutPay", "phoneNumber", "contacts", "isActiveReviews"],
    data() {
        const hostName = window.location.host.replace('.tpay.skyservice.online', '');
        return {
            isLangOpen: false,
            isWork: false,
            isOpenShedule: false,
            menuLink: "http://night-city.com.ua/misc/menu_restorana.pdf",
            hostName: hostName,
            buttonWhite: false


        };
    },
    components: {
        TermsLinks,
        CardBrandsMark
    },
    methods: {
        openPay() {
            // Якщо в URL вже є skyservice=pay, то не варто відкривати сторінку вдруге.

            //         const currentUrl = window.location.href;
            // if (!currentUrl.includes('skyservice=pay')) {
            //     window.open(currentUrl + '&skyservice=pay', "_blank");
            // } else {
            //     console.warn("Оплата вже відкрита.");
            // }




            // window.open(window.location.href + '&skyservice=pay', "_blank");
            window.location.href = window.location.href + '&skyservice=pay';

        },
        openMenu() {
            // const link = this.menuLink;
            // ! link
            const menuUrl = `https://${this.hostName}.menu.skyservice.online/?tpayid=${store.tpayId}`;
            if (menuUrl) {
                // window.open(menuUrl, "_blank", "noopener,noreferrer");
                window.location.href = menuUrl; // Відкриває посилання у тому ж вікні

            } else {
                console.warn("Посилання не задане!");
            }
        },
        callWaiter() {
            // const params = new URLSearchParams(window.location.search);
            // const tpayid = params.get('tpayid');

            const messageSend = {
                "qrToken": `${store.tpayId}`,
                "action": 'callWaiter',
                "hallId": this.hallId,
                "tradepointId": this.tradepointId,
                "tableId": this.tableId
            }
            // Відкриваємо сторінку якщо помилка
            this.$emit("updateForUpdateOpenPage", navigator.START_PAGE);
            sendSocketTypayGuest(messageSend);

        },
        Openreviews() {
            this.$emit("changePage", navigator.REVIEWS);


            // console.log("Before:", this.currentPage);
            // this.currentPage = navigator.REVIEWS;
            // console.log("After:", this.currentPage);
            // this.$emit("updateForUpdateOpenPage", navigator.REVIEWS);

            // window.location.href = window.location.href + '&skyservice=reviews';
            // this.currentPage = navigator.REVIEWS
        },


        callPay() {
            const messageSend = {
                "qrToken": `${store.tpayId}`,
                "action": 'callWaiter',
                "hallId": this.hallId,
                "tradepointId": this.tradepointId,
                "tableId": this.tableId


            }
            sendSocketTypayGuest(messageSend);
        },
        changeLanguage(lang) {
            store.setLanguage(lang)
        }
    },
    computed: {
        workTimeArray() {
            if (!this.workTime) return [];
            const { monday, tuesday, wednesday, thursday, friday, saturday, sunday } = this.workTime;
            return [monday, tuesday, wednesday, thursday, friday, saturday, sunday]
        },
        lang() {
            return store.lang;
        },
        // Перевірка всіх днів, якщо всі false то не малюємо графік
        isAnyWorkTimeOpen() {
            return this.workTimeArray.some(day => day.isOpen);
        },
        langData() {
            const currentLang = store.currentLang;
            return {
                currentLang,
                nextLang: currentLang === 'uk' ? 'eng' : 'uk'
            }
        },
        currentDate() {
            if (!this.workTime) return null;
            const daysOfWeekEng = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
            const current = this.workTime[daysOfWeekEng[new Date().getDay()]];
            const { endTiem, startTiem } = current;
            current.isOpenNow = getIsCurrentWorkTimeIn(startTiem, endTiem)
            return current
        },
        googleMapsLink() {
            return this.contacts ? `https://maps.google.com?q=${encodeURIComponent(this.contacts)}` : "#";
        },
    },


};

</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    background-color: transparent;
    text-decoration: none;
}


body {
    background-color: rgb(244, 244, 244);
}

.gap-20 {
    gap: 4px !important;
}

.m-t-20 {
    margin-top: 10px !important;
}

.center-row {
    display: flex;
    justify-content: center !important;
    align-items: center !important;
}

.page {
    width: 100%;
    height: 100vh;
    /* overflow-y: auto; */
    /* overflow-y: hidden; */
    /* background: var(--head) !important; */
    background: var(--app-bg) !important;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;

}

header {
    position: relative;
    width: 100%;
}


/* lang */
.header-lang {
    position: absolute;
    right: 25px;
    top: 25px;
    display: flex;
    justify-content: center;
}

.header-lang-c {
    height: 45px;
    display: flex;
    align-items: center;
    gap: 9px;
    padding: 4px 13px;
    border-radius: 60px;
    background: rgb(244, 244, 244);
    z-index: 10;
    /* border-color: var(--button) !important;
    color: var(--text-button) !important; */
}

.header-lang-text {
    color: rgb(67, 67, 67);
    /* font-family: Montserrat; */
    font-family: "Montserrat", serif;
    font-size: 14px;
    font-weight: 700;
}

.header-lang-b {
    top: 0;
    position: absolute;
    border-radius: 0px 0px 20px 20px;
    background: rgb(67, 67, 67);
    display: flex;
    align-items: flex-end;
    justify-content: center;
    transition: all .2s;
    width: 0;
}

.header-lang-b.open {

    width: 100%;
    top: 22.5px;
    padding-bottom: 17px;
    padding-top: 43px;
}

.header-lang-text-b {
    color: rgb(244, 244, 244);
    /* font-family: Montserrat; */
    font-family: "Montserrat", serif;
    font-size: 14px;
    font-weight: 700;
}

/* logo */
.header-logo-c {
    position: absolute;
    bottom: -45px;
    left: 10px;
    border-radius: 100%;
    width: 90px;
    height: 90px;
    background: var(--app-bg) !important;

    /* border: 3px solid white; */
}

.header-logo-img {
    border-radius: 100%;
    width: 100%;
    height: 100%;
}

.header-bg {
    width: 100%;
    object-fit: cover;
    max-height: 300px;
}

/* main */
main {
    padding: 58px 11px 5px 11px;
    background-color: rgb(244, 244, 244);
    /* background: var(--head) !important; */
    background: var(--app-bg) !important;

    display: flex;
    flex-direction: column;


}

.hero-c {}

.title-shop-c {
    margin-bottom: 20px;
}

.title-shop {
    color: rgb(67, 67, 67);
    font-family: "Manrope", serif;
    font-size: 24px;
    font-weight: 800;
    line-height: 120%;
    color: var(--text-head) !important;
}

/* btn */
.hero-btn-g-g {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 10px;
}

.hero-btn-g {
    width: 100%;
    border-radius: 17px;
    /* background: rgb(255, 255, 255); */
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    height: 70px;

    padding: 0 24px;
    box-shadow: 0 1px 12px rgba(0, 0, 0, 0.1);

    /* background: var(--button) !important; */

}

.hero-btn-c {
    display: flex;
    align-items: center;
    gap: 8px;
}

.hero-btn-icon-start {}

.hero-btn-title {
    /* color: rgb(67, 67, 67); */
    font-family: "Manrope", serif;
    font-size: 18px;
    font-weight: 800;
    /* color: var(--text-button) !important; */
}

.hero-btn-icon-arrow-right {}

/* shedule */

.shedule-g {
    width: 100%;
    border-radius: 8px;
    /* background: rgb(255, 255, 255); */
    padding: 0 16px;
    margin-top: 16px;
    /* background: var(--button) !important; */
    /* box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.12); */

}

.shedule-title-g {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.shedule-title-c {
    display: flex;
    align-items: center;
}

.shedule-title-icon-menu {
    margin-right: 11px;
}

.shedule-title {
    /* color: rgb(67, 67, 67); */
    font-family: "Manrope", serif;
    font-size: 16px;
    font-weight: 800;
    /* color: var(--text-button) !important; */

}

.shedule-title-right {
    display: flex;
    align-items: center;
    padding: 4px;
    gap: 4px;
    border-radius: 4px;
    /* background: rgb(225, 248, 232); */

}

.shedule-title-ball {
    width: 7px;
    height: 7px;
    border-radius: 100%;
    /* background: rgb(247, 166, 17); */
    background: rgb(65, 187, 83);
    /* background: var(--button) !important; */
    opacity: 0.5;
}

.shedule-title-text {
    /* color: rgb(65, 187, 83); */
    font-family: "Manrope", serif;
    font-size: 13px;
    font-weight: 500;
    color: var(--text-head) !important;
}

.shedule-title-right.close {}

/* menus */

.shedule-menus-g {
    margin-top: 13px;
    margin-bottom: 10px;
}

.shedule-menus-c {
    display: flex;
    align-items: flex-start;
    /* align-items: center; */
    gap: 9px;


}

.shedule-menus-c-cont {
    align-items: center;
    display: flex;
    justify-content: space-between;
    border-radius: 4px;
    padding: 2px 4px;
    gap: 17px;
    /* background: var(--button) !important; */
}

.shedule-menus-c-cont.current span {
    /* color: orange !important; */
    font-weight: 900 !important;
    /* color:  var(--button) !important; */

}

.shedule-day-week {
    /* color: rgb(67, 67, 67); */
    font-family: "Manrope", serif;
    font-size: 13px;
    font-weight: 500;
    color: var(--text-head) !important;


}

.shedule-time-work {
    /* color: rgb(67, 67, 67); */
    font-family: "Manrope", serif;
    font-size: 13px;
    font-weight: 700;
    white-space: nowrap;
    /* color: var(--text-button) !important; */


}

.shedule-icon-arrow {
    margin-top: 2.5px;
    margin-left: 25px;
}

.open .shedule-icon-arrow {
    transform: rotate(180deg);

}


.shedule-menus-cont-menu {
    display: flex;
    flex-direction: column;
    gap: 5px;
    position: relative;

}

.shedule-menus-c.close .shedule-menus-cont-menu-list {
    display: none;
}

.shedule-menus-c.open {
    gap: 36px;
}

.shedule-menus-cont-menu-list {
    display: flex;
    flex-direction: column;
    gap: 5px;
    /* position: absolute; */
    border-radius: 8px;
    /* box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.12); */
    /* background: rgb(255, 255, 255); */
    /* padding: 8px; */
    /* width: calc(100% + 16px); */
    width: auto;
    /* background: var(--head) !important; */
    background: var(--app-bg) !important;



    /* top: 32.5px; */
}

.bottom-container {
    padding: 7px;
    margin-top: 10px;
}

.adress-text {
    font-size: 14px;
}

.phone {
    font-size: 14px;
}

/* phone */

.hero-btn-icon-start-c {
    width: 45px;
    height: 45px;
    border-radius: 60px;
    background: rgb(127, 127, 127);
    display: flex;
    justify-content: center;
    align-items: center;
}

/* 16px, більше за внутрішні 8px між самими знаками: інакше посилання й два
   знаки читаються як три однакові елементи, а не як підпис плюс група. */
.footer-row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
}

/* .terms-links тягнеться на всю ширину, щоб центруватись самостійно; у рядку
   зі знаками це відтіснило б їх до правого краю. */
.footer-row .terms-links {
    width: auto;
}

footer {
    /* position: fixed;
    bottom: 0; */
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* 4px — як у qr-menu: посилання на умови читається як підпис до рядка
       «Powered by», а не як окремий блок. */
    gap: 4px;
    padding: 11px;
    text-align: center;
    /* background: var(--head) !important; */
    background: var(--app-bg) !important;

    /* margin: 24px 0; */
    /* position: absolute; */
    /* position: sticky; */

}

/* line-height: 1 — у qr-menu це глобальне значення body, тут його треба
   виставити явно, інакше рядки розходяться і gap 4px не читається. */
.footer-title {
    color: rgb(67, 67, 67);
    font-family: "Manrope", serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 1;
    color: var(--text-head) !important;
    /* color: var(--text_innerBody) !important; */
}

.footer-text {
    /* color: rgb(67, 67, 67); */
    font-family: "Manrope", serif;
    font-size: 14px;
    font-weight: 700;
    color: var(--text-head) !important;
    transition: opacity 0.2s ease;
}

.footer-text:hover {
    opacity: 0.8;
}

a {
    all: unset;
    cursor: pointer;
}

a:visited,
a:active,
a:focus {
    color: inherit;
    text-decoration: none;
}

@media screen and (max-width: 550px) {
    main {
        padding: 50px 11px 5px 11px;
    }
}

@media screen and (max-width: 450px) {
    main {
        padding: 45px 11px 5px 11px;
    }
}
</style>
